module.exports = __webpack_public_path__ + "img/BibleStudyBG.38600fdf.jpg";